const statusFilterConstantsAr = {
  statusPlaceholder: 'الحالة',
  allFilter: 'الكل',
  newFilter: 'جديد',
  pendingFilter: 'قيد الانتظار',
  rejectedFilter: 'مرفوض',
  approvedFilter: 'موافق عليه',
};
export default statusFilterConstantsAr;
